import { alpha, IconButton, Paper, styled } from '@mui/material';

export const SectionHeader = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 2, 1.5),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const SectionContent = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  padding: theme.spacing(0, 2, 2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 3, 3),
  },
}));

export const RemoveExperimentIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
}));

export const SectionContainer = styled(Paper)(({ theme }) => ({
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius * 1.4,
  boxShadow: `0 1px 2px ${alpha(
    theme.palette.common.black,
    theme.palette.mode === 'dark' ? 0.18 : 0.03,
  )}`,
}));
